let productFormId = document.querySelector('#formId').value
let currentPopup = document.querySelector(`.modal-custom`)
const addBtn = document.querySelector('.customize-submit');
const sideVariantPrice = document.querySelector('.selected-variant-Left-Right');
const bothVariantPrice = document.querySelector('.selected-variant-Both');

let mainOptions = document.querySelectorAll('input[name="location"]');
if (mainOptions.length > 0) {
  mainOptions[0].checked = true; // Check the first available option
}

let sideOptions = document.querySelectorAll('input[name="placement_side"]');
if (sideOptions.length > 0) {
  sideOptions[0].checked = true; 
   // document.querySelector('input[name="placement_side"]:checked').dispatchEvent(new Event('change', {bubbles: true}))
}

addBtn.setAttribute("disabled",true)
function openPopup(button){
    document.querySelectorAll('header, .product-sticky-bar, .shopify-section--announcement-bar').forEach(item => item.style = 'z-index: 1;' )
    currentPopup.style = 'visibility: visible; opacity: 1';
}

function closePopup(){
  if(document.querySelector('.product-sticky-bar')){
    document.querySelector('.product-sticky-bar').style = 'z-index: 3'
  }
    document.querySelector('header').style = 'z-index: 4'
    document.querySelector('.shopify-section--announcement-bar').style = 'z-index: 5'
    currentPopup.style = 'visibility: hidden; opacity: 0';
}

let mainOption = document.querySelector('input[name="location"]:checked')
let selectedVal = mainOption.value;
let selectedSide = document.querySelector('input[name="placement_side"]:checked');
// placement_type
if(selectedVal == 'heel'){
  // document.querySelector('.placement').style.display = 'block';
  selectedSide = document.querySelector('input[name="placement_type"]:checked');
}
if(document.querySelector('input[name="placement"]')){
  let placeMentElem = document.querySelector('.placement')
  let placeMent = document.querySelector('input[name="placement"]:checked')
}
document.querySelectorAll('.prev-opt').forEach(item => {item.style.display = 'none';});

document.querySelector(`.prev-opt.opt-${selectedVal}`).style.display = 'block';

document.querySelectorAll(`.prev-opt.opt-${selectedVal} img`).forEach(item => {item.style.display = 'none';});
// if(selectedVal == 'heel' || selectedVal == 'innerSole'){
//   document.querySelector('.'+selectedVal+'prev').style.display = 'block';
// }else{
//   document.querySelector('.'+selectedVal+'prev-'+selectedSide.value).style.display = 'block';
// }
if(selectedVal == 'innerSole'){
  document.querySelector('.'+selectedVal+'prev').style.display = 'block';
  document.querySelector('.max-chars .field-title').innerText = 'Max 15 Characters'
  document.querySelectorAll('.max-chars input').forEach(item => {
    item.setAttribute("maxlength",15)
  })
}else{
  document.querySelector('.'+selectedVal+'prev-'+selectedSide.value).style.display = 'block';
}
// document.querySelector('.'+selectedVal+'prev-'+selectedSide.value).style.display = 'block';

document.querySelectorAll('.max-chars-block input').forEach(item => { item.style.display = 'none' })
if(selectedSide.value == 'left' || selectedSide.value == 'right'){
  selectedSide.value == 'left' ? document.querySelector('#left').style.display = 'block' : document.querySelector('#right').style.display = 'block'
}else{
    document.querySelectorAll('.max-chars-block input').forEach(item => { item.style.display = 'block' })
}

document.querySelector('.placement').style.display = 'none'
if(selectedVal == 'heel' || selectedVal == 'innerSole'){
  document.querySelector('.placement').style.display = 'block';
}

document.querySelector('input[name="properties[engrave-style]"]').value = selectedVal == 'bottom' ? 'sole' : selectedVal

setActiveInputs();

function setActiveInputs(){
      let currentVal = document.querySelector('input[name="location"]:checked').value;
      let selectedSide = document.querySelector('input[name="placement_side"]:checked');
      let heelSide = document.querySelector('input[name="placement_type"]:checked');
      let fontOption = document.querySelector('input[name="custom-fonts"]:checked').value;
      
      if(this.name != 'custom-fonts'){
        document.querySelector('#left').value = ''
        document.querySelector('#right').value = ''
        document.querySelectorAll('.textover-'+currentVal).forEach(item => {
          item.style.display = 'none';
        })
      }else{
        document.querySelectorAll('.textover').forEach(textElem => {
           textElem.setAttribute("data-font",fontOption)
        })
      }
  
      document.querySelectorAll('.prev-opt').forEach(item => {item.style.display = 'none';});
      document.querySelectorAll(`.prev-opt.opt-${currentVal} img`).forEach(item => {item.style.display = 'none';});
      
      document.querySelector('.prev-opt.opt-'+currentVal).style.display = 'block';
      document.querySelector('.placement').style.display = 'none'
      switch(currentVal){
        case "heel":
          document.querySelector('.max-chars .field-title').innerText = 'Max 15 Characters'
          document.querySelectorAll('.max-chars input').forEach(item => {
            item.setAttribute("maxlength",15)
          })
            document.querySelector('input[name="properties[engrave-type]"]').value = heelSide.value;
            // document.querySelector('input[name="properties[engrave-type]"]').value = heelSide.value;
          document.querySelector('input[name="properties[engrave-type]"]').setAttribute("form", productFormId);
           document.querySelector('.placement').style.display = 'block'
            document.querySelector('.'+currentVal+'prev-'+heelSide.value).style.display = 'block';

          if (document.querySelector("[name='placement_type']:checked").value === 'inner') {
            document.querySelector('.textover-heel').classList.add('textover-heel-inner');
          } else {
            document.querySelector('.textover-heel').classList.remove('textover-heel-inner');
          }
          break;
        case "innerSole":
          document.querySelector('.max-chars .field-title').innerText = 'Max 15 Characters'
          document.querySelectorAll('.max-chars input').forEach(item => {
            item.setAttribute("maxlength",15)
          })
            document.querySelector('input[name="properties[engrave-type]"]').value = heelSide.value;
           document.querySelector('.placement').style.display = 'block'
            // document.querySelector('.'+currentVal+'prev-'+heelSide.value).style.display = 'block';
          document.querySelector('.'+currentVal+'prev').style.display = 'block';
          break;
        case "bottom": 
          document.querySelector('input[name="properties[engrave-type]"]').removeAttribute("form");
          document.querySelector('.max-chars .field-title').innerText = 'Max 10 Characters'
          document.querySelectorAll('.max-chars input').forEach(item => {
            item.setAttribute("maxlength",10)
          })
          document.querySelector('.'+currentVal+'prev').style.display = 'block';
          break;
        default:
          document.querySelector('input[name="properties[engrave-type]"]').removeAttribute("form");
          document.querySelector('.max-chars .field-title').innerText = 'Max 3 Characters'
          document.querySelectorAll('.max-chars input').forEach(item => {
            item.setAttribute("maxlength",3)
          })
          document.querySelector('.'+currentVal+'prev-'+selectedSide.value).style.display = 'block';
          break;
      }

      document.querySelectorAll('.max-chars-block input').forEach(item => { item.style.display = 'none' })
      if(selectedSide.value == 'left' || selectedSide.value == 'right'){
        (selectedSide.value == 'left') ? document.querySelector('#left').style.display = 'block' : document.querySelector('#right').style.display = 'block'
        document.querySelector('.text_info').style.display = 'none';
        if(sideVariantPrice){
          addBtn.innerText = `+${sideVariantPrice.getAttribute("data-price")} - Add To Cart`
          document.querySelector('.customization-productId').value = sideVariantPrice.value
        }
      }else{
          document.querySelector('.text_info').style.display = 'block';
          document.querySelectorAll('.max-chars-block input').forEach(item => { item.style.display = 'block' })
        if(bothVariantPrice){ 
          addBtn.innerText = `+${bothVariantPrice.getAttribute("data-price")} - Add To Cart`
          document.querySelector('.customization-productId').value = bothVariantPrice.value
        }
      }


    document.querySelector('input[name="properties[engrave-style]"]').value = currentVal == 'bottom' ? 'sole' : currentVal;
    document.querySelector('input[name="properties[Personalize]"]').value = selectedSide.value;
  
    addBtnStyle()
}
document.querySelectorAll('input[name="placement_side"]').forEach(item => {
  item.addEventListener('change', addBtnStyle)
})
document.querySelectorAll('.max-chars-block input').forEach(item => {
  item.addEventListener('keyup', addBtnStyle)
})

document.querySelector('#agree').addEventListener('change',addBtnStyle)

function addBtnStyle(){
  let currentVal = document.querySelector('input[name="placement_side"]:checked').value;
  let mainOption = document.querySelector('input[name="location"]:checked').value;
  let placement_type = document.querySelector('input[name="placement_type"]:checked').value;
    let disableBtn =  false;
    if(currentVal == 'left'){
      disableBtn = document.querySelector('#left').value != '' ? false : true;
      if(document.querySelector(`input[name="properties[right_text]"]`)){
        document.querySelector(`input[name="properties[right_text]"]`).remove()
      }
    }else if(currentVal == 'right'){
      disableBtn = document.querySelector('#right').value != '' ? false : true;
      if(document.querySelector(`input[name="properties[left_text]"]`)){ 
        document.querySelector(`input[name="properties[left_text]"]`).remove()
      }
    }else{
       disableBtn = (document.querySelector('#left').value != '' && document.querySelector('#right').value != '') ? false : true;
    }
  
  
    // disableBtn ? addBtn.setAttribute("disabled",true) : addBtn.removeAttribute("disabled")
  
    // disableBtn = document.querySelector('#agree').checked ? false : true;
    if(document.querySelector('#agree').checked && !disableBtn){
      addBtn.removeAttribute("disabled")
    }else{
      addBtn.setAttribute("disabled",true)
    }
  
    let leftValue = document.querySelector('#left')?.value || "";
    let rightValue = document.querySelector('#right')?.value || "";
    // let existingInput = document.querySelector('input[name="properties[left_text]"]');
  
    handleInput("left_text", leftValue);
    handleInput("right_text", rightValue);

    let longerText = leftValue.length >= rightValue.length ? leftValue : rightValue;
    switch(mainOption){
      case "heel":
        document.querySelector('.textover-heel').style.display = 'block';
        document.querySelector('.textover-heel span').innerText = longerText;
        // document.querySelector('.textover-heel').style = placement_type == 'inner' ? 'left: 9%; top: 67%;' : 'right: 8%;';
        break;
      case "bottom":
        // document.querySelector('.textover-bottom').style.display = 'block';
        // document.querySelector('.textover-bottom span').innerText = longerText;
        if(currentVal != 'both'){
          document.querySelector('.prev-opt.opt-vamp')?.classList.remove('both')
          if(leftValue != ''){  
            document.querySelector(`.textover-bottom-${currentVal}`).style.display = 'block';
            document.querySelector(`.textover-bottom-left span`).innerText = leftValue
          }else if(rightValue != ''){
            document.querySelector(`.textover-bottom-${currentVal}`).style.display = 'block';
            document.querySelector(`.textover-bottom-right span`).innerText = rightValue
          }else{
            document.querySelector(`.textover-bottom-${currentVal}`).style.display = 'none';
            document.querySelector(`.textover-bottom-left span`).innerText = ''
            document.querySelector(`.textover-bottom-${currentVal}`).style.display = 'none';
            document.querySelector(`.textover-bottom-right span`).innerText = ''  
          }
        }else{
          document.querySelector('.prev-opt.opt-vamp')?.classList.add('both')
          document.querySelector(`.textover-bottom-left span`).innerText = leftValue
          document.querySelector(`.textover-bottom-right span`).innerText = rightValue
          document.querySelector(`.textover-bottom-left`).style.display = 'block';
          document.querySelector(`.textover-bottom-right`).style.display = 'block';
        }
        break;
      case "innerSole":
        document.querySelector('.textover-innerSole').style.display = 'block';
        document.querySelector('.textover-innerSole span').innerText = longerText;
        break;
      default: 
        if(currentVal != 'both'){
          document.querySelector('.prev-opt.opt-vamp').classList.remove('both')
          if(leftValue != ''){  
            document.querySelector(`.textover-${mainOption}.textover-${currentVal}`).style.display = 'block';
            document.querySelector(`.textover-${mainOption}.textover-left span`).innerText = leftValue
          }else if(rightValue != ''){
            document.querySelector(`.textover-${mainOption}.textover-${currentVal}`).style.display = 'block';
            document.querySelector(`.textover-${mainOption}.textover-right span`).innerText = rightValue
          }else{
            document.querySelector(`.textover-${mainOption}.textover-${currentVal}`).style.display = 'none';
            document.querySelector(`.textover-${mainOption}.textover-left span`).innerText = ''
            document.querySelector(`.textover-${mainOption}.textover-${currentVal}`).style.display = 'none';
            document.querySelector(`.textover-${mainOption}.textover-right span`).innerText = ''  
          }
        }else{
          document.querySelector('.prev-opt.opt-vamp').classList.add('both')
          document.querySelector(`.textover-${mainOption}.textover-left span`).innerText = leftValue
          document.querySelector(`.textover-${mainOption}.textover-right span`).innerText = rightValue
          document.querySelector(`.textover-${mainOption}.textover-left`).style.display = 'block';
          document.querySelector(`.textover-${mainOption}.textover-right`).style.display = 'block';
        }
        break;
    }

    if(document.querySelector('.customize-submit').getAttribute("disabled") && document.querySelector('.customize-submit').getAttribute("disabled") == 'true'){
      document.querySelectorAll('.customization-button-wrapper input').forEach(input => {
        input.removeAttribute("form")
      })
    }else{
      document.querySelectorAll('.customization-button-wrapper input').forEach(input => {
        // if((document.querySelector('input[name="location"]:checked').value == 'vamp' || document.querySelector('input[name="location"]:checked').value == 'bottom') && input.name != 'properties[engrave-type]'){
        // if((document.querySelector('input[name="location"]:checked').value == 'vamp' || document.querySelector('input[name="location"]:checked').value == 'bottom') && input.name != 'properties[engrave-type]'){
        //   input.setAttribute("form",productFormId)
        // }
        if((document.querySelector('input[name="location"]:checked').value == 'vamp' || document.querySelector('input[name="location"]:checked').value == 'bottom')){
          if(input.name != 'properties[engrave-type]'){
            input.setAttribute("form",productFormId)
          }
        }else{
            input.setAttribute("form",productFormId)
        }
        
          // input.setAttribute("form",productFormId)
      })
    }
  document.querySelector('input[name="properties[font]"]').value = document.querySelector('input[name="custom-fonts"]:checked').value;
}
document.querySelector('.customize-submit').addEventListener('click', () => {
  let randomNumber = Math.round(Math.random()*10000);
  document.querySelector('.isMainProduct').setAttribute("form", productFormId)
  document.querySelector('.require_personalization').setAttribute("form", productFormId)
  document.querySelectorAll('.partNum').forEach(input => {
    input.value = randomNumber
    input.setAttribute("form", productFormId)
  })
  closePopup()
})

function handleInput(name, value) {
    let inputContainer = document.querySelector(".customization-button-wrapper");
    let existingInput = document.querySelector(`input[name="properties[${name}]"]`);
    if (value) {
        if (!existingInput) {
            let newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = `properties[${name}]`;
            newInput.value = value;
            newInput.setAttribute("form", productFormId);
            inputContainer.appendChild(newInput);
        } else {
            existingInput.value = value;
        }
    } else if (existingInput) {
        existingInput.remove();
    }
}

document.querySelectorAll('input[type="radio"]').forEach(input => {
    input.addEventListener('change', setActiveInputs)
})
if(document.querySelector('.customize-submit').getAttribute("disabled") && document.querySelector('.customize-submit').getAttribute("disabled") == 'true'){
  document.querySelectorAll('.customization-button-wrapper input').forEach(input => {
    input.removeAttribute("form")
  })
}else{
  document.querySelectorAll('.customization-button-wrapper input').forEach(input => {
    input.setAttribute("form",productFormId)
  })
}

document.querySelector('.custom-add button[type="submit"]').addEventListener('click', ()=>{
  document.querySelectorAll('.customization-button-wrapper input').forEach(input => {
      input.removeAttribute("form")
  })
})